import React from "react";

import { TbLayoutCollage, TbPhoto } from "react-icons/tb";

import { IoSettingsOutline } from "react-icons/io5";
import { LuHeadphones } from "react-icons/lu";
import { Link } from "react-router-dom";

function Sidebar1() {
  return (
    <>
      <div className="leftMenu">
        <div className="leftSideBar">
          <div className="logoItem">
            <a href="#">
              {/* <Link to="/"> <img src='Image/logo.png' /></Link> */}
              <p>Greymatterz Admin Dashboard</p>
            </a>
          </div>
          <div className="menuBar">
            <ul>
              <li>
                <Link to="/home">
                  <TbLayoutCollage className="icon" /> User Details{" "}
                </Link>
              </li>
              <li>
                <Link to="/Blogs">
                  <TbLayoutCollage className="icon" /> Blogs{" "}
                </Link>
              </li>
              <li>
                <Link to="/Webinars">
                  <TbLayoutCollage className="icon" /> Webinars{" "}
                </Link>
              </li>
              <li>
                <Link to="/News">
                  <TbLayoutCollage className="icon" /> News{" "}
                </Link>
              </li>
              <li>
                <Link to="/Jobs">
                  <TbLayoutCollage className="icon" /> Jobs{" "}
                </Link>
              </li>
              <li>
                <Link to="/editior">
                  <TbLayoutCollage className="icon" /> Editior{" "}
                </Link>
              </li>
              <li></li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sidebar1;
